// mixins/notificationMixin.js
export default {
    data() {
        return {
            unread_count: 0,
            ws: null,
        };
    },
    created() {
        this.initNotificationWebSocket();
    },
    beforeDestroy() {
        if (this.ws) {
            this.ws.close();
        }
    },
    methods: {
        initNotificationWebSocket() {
            // 1. 建立连接，URL 通常由父组件传入或从配置读取
            const wsUrl = this.wsUrl || 'wss://hlwyy.sgdoctor.cn:8090?info=getSysCount&action_id=11496&action=1';
            this.ws = new WebSocket(wsUrl);

            // 2. 监听连接成功
            this.ws.onopen = () => {
                console.log('通知WebSocket连接成功');
                // 可在此发送身份认证信息
                // this.ws.send(JSON.stringify({ type: 'auth', token: 'xxx' }));
            };

            // 3. 【核心】监听后台推送的提醒
            this.ws.onmessage = (event) => {
                try {
                    const data = JSON.parse(event.data);
                    // 处理不同类型的提醒
                    this.handleIncomingNotification(data);
                } catch (e) {
                    console.error('解析消息错误:', e);
                }
            };

            // 4. 错误和关闭处理
            this.ws.onerror = (error) => console.error('WebSocket错误:', error);
            this.ws.onclose = () => console.log('通知连接关闭');
        },

        handleIncomingNotification(data) {
            console.log(data, '消息列表');
            this.unread_count = data.unread_count;
        },
    },
};
